import * as types from "./actions";

export const loginUser = (userState) => {
  return { type: types.LOGIN_USER, userState };
};
